// daire-detay.js
// Reservation calendar için gelişmiş Lightpick entegrasyonu
let picker = null;
let selectedStart = null;
let selectedEnd = null;

// Mobil kontrol fonksiyonu
function isMobile() {
    return window.innerWidth <= 768;
}

document.addEventListener('DOMContentLoaded', function () {
    const minDays = 100;
    const maxMonths = 12;

    const moveInDisplay = document.getElementById('move-in-display');
    const moveOutDisplay = document.getElementById('move-out-display');
    const quickDatePicker = document.getElementById('quick-date-picker');
    const calendarContainer = document.getElementById('calendar-container');

    if (!quickDatePicker || !calendarContainer) return;

    // MOBİL: Kendi takvim gridini oluştur
    if (isMobile()) {
        let scrollContainer = document.getElementById('mobile-calendar-scroll-container');
        if (!scrollContainer) {
            scrollContainer = document.createElement('div');
            scrollContainer.id = 'mobile-calendar-scroll-container';
            scrollContainer.style.maxHeight = '60vh';
            scrollContainer.style.overflowY = 'auto';
            scrollContainer.style.width = '100%';
            calendarContainer.parentNode.insertBefore(scrollContainer, calendarContainer);
            scrollContainer.appendChild(calendarContainer);
        }
        calendarContainer.innerHTML = '';
        
        const dayNamesHeader = document.createElement('div');
        dayNamesHeader.className = 'daire-detay-calendar-day-names-header';
        const dayNames = ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'];
        dayNames.forEach(function (name) {
            const dayName = document.createElement('div');
            dayName.className = 'daire-detay-calendar-day-name';
            dayName.textContent = name;
            dayNamesHeader.appendChild(dayName);
        });
        calendarContainer.appendChild(dayNamesHeader);

        const today = moment();
        const monthsToRender = 12;
        for (let i = 0; i < monthsToRender; i++) {
            const monthDate = moment().add(i, 'months');
            renderMobileMonth(monthDate, calendarContainer, false);
        }

        function renderMobileMonth(monthDate, container, isFirstMonth) {
            const monthContainer = document.createElement('div');
            monthContainer.className = 'daire-detay-calendar-month';
            monthContainer.dataset.month = monthDate.format('YYYY-MM');

            const monthTitle = document.createElement('div');
            monthTitle.className = 'daire-detay-calendar-month-title';
            monthTitle.textContent = monthDate.locale('tr').format('MMMM YYYY');
            monthContainer.appendChild(monthTitle);

            const grid = document.createElement('div');
            grid.className = 'daire-detay-calendar-grid';

            const startOfMonth = monthDate.clone().startOf('month');
            const endOfMonth = monthDate.clone().endOf('month');
            const startDay = startOfMonth.day();
            
            for (let i = 0; i < startDay; i++) {
                const emptyCell = document.createElement('div');
                emptyCell.className = 'daire-detay-calendar-day disabled';
                grid.appendChild(emptyCell);
            }

            const daysInMonth = endOfMonth.date();
            const minDate = moment().add(1, 'day');
            const maxDate = moment().add(12, 'months');

            for (let day = 1; day <= daysInMonth; day++) {
                const dayDate = monthDate.clone().date(day);
                const dayCell = document.createElement('div');
                dayCell.className = 'daire-detay-calendar-day';
                dayCell.textContent = day;
                dayCell.dataset.date = dayDate.format('YYYY-MM-DD');
                dayCell.dataset.day = day; // data-day attribute ekle
                dayCell.dataset.container = 'mobile';

                if (dayDate.isBefore(minDate, 'day') || dayDate.isAfter(maxDate, 'day')) {
                    dayCell.classList.add('disabled');
                }

                grid.appendChild(dayCell);
            }

            monthContainer.appendChild(grid);
            container.appendChild(monthContainer);
        }

        let isLoadingMore = false;
        scrollContainer.addEventListener('scroll', function () {
            const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
            if (scrollHeight - scrollTop - clientHeight < 200 && !isLoadingMore) {
                isLoadingMore = true;
                const lastMonth = calendarContainer.querySelector('.daire-detay-calendar-month:last-child');
                if (lastMonth) {
                    const lastMonthDate = moment(lastMonth.dataset.month, 'YYYY-MM');
                    for (let i = 1; i <= 3; i++) {
                        const nextMonth = lastMonthDate.clone().add(i, 'months');
                        renderMobileMonth(nextMonth, calendarContainer, false);
                    }
                }
                setTimeout(function () { isLoadingMore = false; }, 100);
            }
        });

        // Mobilde gün seçimi ve inputa yazma
        let mobileSelectedStart = null;
        let mobileSelectedEnd = null;
        calendarContainer.addEventListener('click', function(e) {
            const dayCell = e.target.closest('.daire-detay-calendar-day');
            if (!dayCell || dayCell.classList.contains('disabled')) return;
            
            const clickedDate = moment(dayCell.dataset.date, 'YYYY-MM-DD');
            
            if (!mobileSelectedStart || (mobileSelectedStart && mobileSelectedEnd)) {
                // Yeni seçim başlat
                mobileSelectedStart = clickedDate;
                mobileSelectedEnd = null;
                selectedStart = clickedDate;
                selectedEnd = null;
                
                // Temizle
                calendarContainer.querySelectorAll('.daire-detay-calendar-day.selected, .daire-detay-calendar-day.range, .daire-detay-calendar-day.range-start, .daire-detay-calendar-day.range-end').forEach(function(el){
                    el.classList.remove('selected','range', 'range-start', 'range-end');
                });
                dayCell.classList.add('selected');
                
                if (moveInDisplay) moveInDisplay.textContent = clickedDate.format('D MMM YYYY');
                if (moveOutDisplay) moveOutDisplay.textContent = 'Çıkış tarihi seçin';
                if (quickDatePicker) quickDatePicker.value = clickedDate.format('DD/MM/YYYY');
                
                // +100 gün öncesini disable et
                const minEndDate = clickedDate.clone().add(minDays, 'days');
                const maxEndDate = clickedDate.clone().add(maxMonths, 'months');
                calendarContainer.querySelectorAll('.daire-detay-calendar-day').forEach(function(el){
                    if (el.classList.contains('disabled')) return;
                    const d = moment(el.dataset.date, 'YYYY-MM-DD');
                    if (d.isBefore(minEndDate, 'day') || d.isAfter(maxEndDate, 'day')) {
                        el.classList.add('temp-disabled');
                    } else {
                        el.classList.remove('temp-disabled');
                    }
                });
                
                // Yumuşak scroll ile +100 gün sonraki aya git
                const targetDate = clickedDate.clone().add(minDays, 'days');
                const targetMonthElement = calendarContainer.querySelector(`.daire-detay-calendar-month[data-month="${targetDate.format('YYYY-MM')}"]`);
                
                if (targetMonthElement && scrollContainer) {
                    setTimeout(function() {
                        const containerTop = scrollContainer.offsetTop;
                        const elementTop = targetMonthElement.offsetTop;
                        const scrollTo = elementTop - containerTop - 60; // 60px header için offset
                        
                        scrollContainer.scrollTo({
                            top: scrollTo,
                            behavior: 'smooth'
                        });
                    }, 300);
                }
                
            } else {
                // Bitiş tarihi seçiliyor
                if (clickedDate.isBefore(mobileSelectedStart)) return;
                
                const minEndDate = mobileSelectedStart.clone().add(minDays, 'days');
                if (clickedDate.isBefore(minEndDate, 'day')) return;
                
                mobileSelectedEnd = clickedDate;
                selectedEnd = clickedDate;
                
                // Aralığı vurgula
                calendarContainer.querySelectorAll('.daire-detay-calendar-day').forEach(function(el){
                    const d = moment(el.dataset.date, 'YYYY-MM-DD');
                    el.classList.remove('range', 'range-start', 'range-end', 'selected');
                    
                    if (d.isSame(mobileSelectedStart, 'day')) {
                        el.classList.add('selected', 'range-start');
                    } else if (d.isSame(mobileSelectedEnd, 'day')) {
                        el.classList.add('selected', 'range-end');
                    } else if (d.isAfter(mobileSelectedStart) && d.isBefore(mobileSelectedEnd)) {
                        el.classList.add('range');
                    }
                    
                    el.classList.remove('temp-disabled');
                });
                
                if (moveOutDisplay) moveOutDisplay.textContent = clickedDate.format('D MMM YYYY');
                if (quickDatePicker) quickDatePicker.value = mobileSelectedStart.format('DD/MM/YYYY') + ' - ' + mobileSelectedEnd.format('DD/MM/YYYY');
            }
        });

        // reservation-button ile inputu güncelle
        const reservationBtn = document.querySelector('.reservation-button');
        if (reservationBtn) {
            reservationBtn.addEventListener('click', function () {
                if (mobileSelectedStart && mobileSelectedEnd && quickDatePicker) {
                    quickDatePicker.value = mobileSelectedStart.format('DD/MM/YYYY') + ' - ' + mobileSelectedEnd.format('DD/MM/YYYY');
                }
            });
        }

        return; // Mobilde Lightpick çalıştırma!
    }

    // DESKTOP: Lightpick entegrasyonu (eskisi gibi devam ediyor)
    
    // Modal açıldığında inputtaki tarih aralığını Lightpick'e set et (/cart kısmı için yazıldı)
    function setPickerFromInput() {
        if (!picker) return;
        const value = quickDatePicker.value;
        console.log('[DEBUG] quickDatePicker value:', value);
        if (!value) return;
        // Tarih aralığı formatı: DD/MM/YYYY - DD/MM/YYYY
        const parts = value.split(' - ');
        if (parts.length === 2) {
            const start = moment(parts[0], 'DD/MM/YYYY');
            const end = moment(parts[1], 'DD/MM/YYYY');
            if (start.isValid() && end.isValid()) {
                selectedStart = start;
                selectedEnd = end;
                if (typeof picker.setDateRange === 'function') {
                    picker.setDateRange(start.toDate(), end.toDate());
                } else {
                    picker.setStartDate(start.toDate(), true);
                    picker.setEndDate(end.toDate(), true);
                }
                picker.start = start.toDate();
                picker.end = end.toDate();
                picker._start = start.toDate();
                picker._end = end.toDate();
                if (moveInDisplay) moveInDisplay.textContent = start.format('D MMM YYYY');
                if (moveOutDisplay) moveOutDisplay.textContent = end.format('D MMM YYYY');
                // Takvimi seçili giriş ayına götür ve yeniden çiz
                if (typeof picker.gotoDate === 'function') {
                    picker.gotoDate(start.toDate());
                }
                if (typeof picker.render === 'function') {
                    picker.render();
                }
            }
        }
    }

    // reservationCalendar modal açıldığında tetiklenir
    const reservationCalendarModal = document.getElementById('reservationCalendar');
    if (reservationCalendarModal) {
        reservationCalendarModal.addEventListener('show.bs.modal', function () {
            setTimeout(setPickerFromInput, 100); // Modal animasyonu için küçük gecikme
            setTimeout(setPickerFromInput, 350); // İkinci kez çağır, Lightpick render gecikmesi için
        });
    }

    function updateDisabledDates() {
        if (!picker || !picker.el) return;
        const today = moment().add(1, 'day');
        const maxAllowedDate = moment().add(12, 'months').add(1, 'day');

        setTimeout(() => {
            const days = picker.el.querySelectorAll('.lightpick__day');
            days.forEach(dayElement => {
                const dayTime = parseInt(dayElement.getAttribute('data-time'));
                if (!dayTime) return;

                const dayDate = moment(dayTime);
                let shouldDisable = dayDate.isBefore(today, 'day') || dayDate.isAfter(maxAllowedDate, 'day');

                // Giriş seçiliyse +100 gün öncesi disabled olmalı
                if (!shouldDisable && selectedStart && !selectedEnd) {
                    const minEndDate = moment(selectedStart).add(minDays, 'days');
                    const maxEndDate = moment(selectedStart).add(maxMonths, 'months').add(1, 'day');
                    shouldDisable = dayDate.isBefore(minEndDate, 'day') || dayDate.isAfter(maxEndDate, 'day');
                }

                if (shouldDisable) {
                    dayElement.classList.add('is-disabled');
                    dayElement.classList.remove('is-available');
                } else if (!dayElement.classList.contains('is-start-date') &&
                    !dayElement.classList.contains('is-previous-month') &&
                    !dayElement.classList.contains('is-next-month')) {
                    dayElement.classList.remove('is-disabled');
                    dayElement.classList.add('is-available');
                }
            });
        }, 50);
    }

    picker = new Lightpick({
        field: quickDatePicker,
        singleDate: false,
        numberOfMonths: 2,
        minDate: moment().add(1, 'day').toDate(),
        maxDate: moment().add(12, 'months').add(1, 'day').toDate(),
        inline: true,
        autoclose: false,
        repick: false,
        lang: 'tr',
        parentEl: calendarContainer,
        disableDates: (date) => {
            const dateMoment = moment(date);
            const today = moment().add(1, 'day');
            const maxAllowedDate = moment().add(12, 'months').add(1, 'day');

            if (dateMoment.isBefore(today, 'day') || dateMoment.isAfter(maxAllowedDate, 'day')) {
                return true;
            }

            // Giriş seçiliyse +100 gün öncesi disabled
            if (selectedStart && !selectedEnd) {
                const minEndDate = moment(selectedStart).add(minDays, 'days');
                const maxEndDate = moment(selectedStart).add(maxMonths, 'months').add(1, 'day');
                return dateMoment.isBefore(minEndDate, 'day') || dateMoment.isAfter(maxEndDate, 'day');
            }

            return false;
        },
        onSelect: (start, end) => {
            // Lightpick'in otomatik end seçimini engelle
            if (end && start) {
                const startJustSelected = !selectedStart || (selectedStart && !moment(start).isSame(selectedStart, 'day'));
                if (startJustSelected) {
                    setTimeout(() => {
                        picker.setEndDate(null, true);
                        selectedEnd = null;
                        if (moveOutDisplay) moveOutDisplay.textContent = 'Çıkış tarihi seçin';
                    }, 0);
                    end = null;
                }
            }

            if (!end) {
                // Giriş tarihi seçimi
                if (selectedStart && selectedEnd) {
                    selectedStart = null;
                    selectedEnd = null;
                    picker.setStartDate(null, true);
                    picker.setEndDate(null, true);
                    if (moveOutDisplay) moveOutDisplay.textContent = 'Takvim seçin';
                    if (moveInDisplay) moveInDisplay.textContent = 'Takvim seçin';
                }

                if (selectedEnd) {
                    selectedEnd = null;
                    picker.setEndDate(null, true);
                    if (moveOutDisplay) moveOutDisplay.textContent = 'Çıkış tarihi seçin';
                }

                selectedStart = start ? moment(start) : null;
                selectedEnd = null;

                picker.setStartDate(start, true);
                picker.setEndDate(null, true);

                if (moveOutDisplay) moveOutDisplay.textContent = 'Çıkış tarihi seçin';
                if (moveInDisplay) moveInDisplay.textContent = start ? moment(start).format('D MMM YYYY') : 'Takvim seçin';

                // quickDatePicker inputuna giriş tarihini yaz (DD/MM/YYYY formatında)
                if (quickDatePicker) {
                    quickDatePicker.value = start ? moment(start).format('DD/MM/YYYY') : '';
                }

                // +100 gün sonraki tarihi hesapla
                const targetDate = moment(start).add(minDays, 'days').toDate();

                // Disabled tarihleri güncelle
                setTimeout(() => {
                    updateDisabledDates();
                }, 100);

                // Takvimi +100 gün sonraki aya götür (animasyonlu)
                setTimeout(() => {
                    if (picker.gotoDate) {
                        const monthsContainer = calendarContainer.querySelector('.lightpick__months');
                        const currentMonth = moment(start);
                        const targetMonth = moment(targetDate);
                        const monthsDiff = targetMonth.diff(currentMonth, 'months');

                        let currentStep = 0;
                        const animateToTarget = () => {
                            if (currentStep < monthsDiff) {
                                currentStep++;
                                const nextMonth = moment(start).add(currentStep, 'months').toDate();

                                if (monthsContainer) {
                                    monthsContainer.style.opacity = '0.5';
                                    monthsContainer.style.transition = 'opacity 0.3s ease';
                                }

                                setTimeout(() => {
                                    picker.gotoDate(nextMonth);
                                    updateDisabledDates();

                                    if (monthsContainer) {
                                        setTimeout(() => {
                                            monthsContainer.style.opacity = '1';
                                        }, 50);
                                    }
                                }, 100);

                                setTimeout(animateToTarget, 400);
                            } else {
                                // Son pozisyon: +100 günlük tarihi göster
                                picker.gotoDate(targetDate);

                                setTimeout(() => {
                                    if (picker.render) {
                                        picker.render();
                                    }
                                    updateDisabledDates();

                                    if (monthsContainer) {
                                        monthsContainer.style.opacity = '1';
                                    }
                                }, 100);
                            }
                        };

                        animateToTarget();
                    }
                }, 50);

            } else {
                // Çıkış tarihi seçimi
                selectedStart = start ? moment(start) : null;
                selectedEnd = end ? moment(end) : null;

                if (moveInDisplay) moveInDisplay.textContent = start ? moment(start).format('D MMM YYYY') : 'Takvim seçin';
                if (moveOutDisplay) moveOutDisplay.textContent = end ? moment(end).format('D MMM YYYY') : 'Çıkış tarihi seçin';

                // quickDatePicker inputuna tam tarih aralığını yaz (DD/MM/YYYY - DD/MM/YYYY formatında)
                if (quickDatePicker) {
                    quickDatePicker.value = `${moment(start).format('DD/MM/YYYY')} - ${moment(end).format('DD/MM/YYYY')}`;
                }

                updateDisabledDates();
            }
        }
    });

    // Takvimde aylar arası geçişte animasyon
    setTimeout(() => {
        const monthsContainer = calendarContainer.querySelector('.lightpick__months');
        const prevButton = calendarContainer.querySelector('.lightpick__previous-action');
        const nextButton = calendarContainer.querySelector('.lightpick__next-action');

        if (prevButton && monthsContainer) {
            prevButton.addEventListener('click', () => {
                monthsContainer.style.transform = 'translateX(-20px)';
                monthsContainer.style.opacity = '0.5';
                setTimeout(() => {
                    monthsContainer.style.transform = 'translateX(0)';
                    monthsContainer.style.opacity = '1';
                    updateDisabledDates();
                }, 150);
            });
        }

        if (nextButton && monthsContainer) {
            nextButton.addEventListener('click', () => {
                monthsContainer.style.transform = 'translateX(20px)';
                monthsContainer.style.opacity = '0.5';
                setTimeout(() => {
                    monthsContainer.style.transform = 'translateX(0)';
                    monthsContainer.style.opacity = '1';
                    updateDisabledDates();
                }, 150);
            });
        }
    }, 100);
});

// Global fonksiyon: Takvimi temizle
window.clearPicker = function () {
    const moveInDisplay = document.getElementById('move-in-display');
    const moveOutDisplay = document.getElementById('move-out-display');
    const quickDatePicker = document.getElementById('quick-date-picker');
    const calendarContainer = document.getElementById('calendar-container');

    // Seçimleri sıfırla
    selectedStart = null;
    selectedEnd = null;

    if (isMobile()) {
        // Mobil takvimi temizle
        if (calendarContainer) {
            calendarContainer.querySelectorAll('.daire-detay-calendar-day.selected, .daire-detay-calendar-day.range, .daire-detay-calendar-day.temp-disabled, .daire-detay-calendar-day.range-start, .daire-detay-calendar-day.range-end').forEach(function(el){
                el.classList.remove('selected', 'range', 'temp-disabled', 'range-start', 'range-end');
            });
        }
    } else {
        // Desktop Picker'ı sıfırla
        if (picker) {
            picker.setStartDate(null, true);
            picker.setEndDate(null, true);

            // Takvimi bugüne (yarına) götür
            picker.gotoDate(moment().add(1, 'day').toDate());
        }

        // Disabled günleri güncelle (tümü aktif olacak)
        setTimeout(() => {
            if (picker && picker.el) {
                const today = moment().add(1, 'day');
                const maxAllowedDate = moment().add(12, 'months');

                const days = picker.el.querySelectorAll('.lightpick__day');
                days.forEach(dayElement => {
                    const dayTime = parseInt(dayElement.getAttribute('data-time'));
                    if (!dayTime) return;

                    const dayDate = moment(dayTime);
                    const shouldDisable = dayDate.isBefore(today, 'day') || dayDate.isAfter(maxAllowedDate, 'day');

                    if (shouldDisable) {
                        dayElement.classList.add('is-disabled');
                        dayElement.classList.remove('is-available');
                    } else if (!dayElement.classList.contains('is-previous-month') &&
                        !dayElement.classList.contains('is-next-month')) {
                        dayElement.classList.remove('is-disabled');
                        dayElement.classList.add('is-available');
                    }
                });
            }
        }, 100);
    }

    // Display'leri sıfırla
    if (moveInDisplay) moveInDisplay.textContent = 'Takvim seçin';
    if (moveOutDisplay) moveOutDisplay.textContent = 'Takvim seçin';

    // Input'u temizle
    if (quickDatePicker) quickDatePicker.value = '';
};

/* Ürün Detay Takvim Üstü Aylık Üçret ve Takvim otomasyonu sağ sol ok slider geçişleri */
document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        var inner = document.getElementById('dateScrollerInner');
        var leftBtn = document.getElementById('dateScrollerLeft');
        var rightBtn = document.getElementById('dateScrollerRight');
        if (!inner || !leftBtn || !rightBtn) return;
        
        var items = inner.querySelectorAll('.daire-detay-date-list__item');
        var gap = 20;
        var isDown = false;
        var startX;
        var scrollLeft;
        function getItemWidth() {
            if (items.length > 0) return items[0].offsetWidth;
            return 120;
        }
        function updateArrows() {
            var scrollLeftVal = inner.scrollLeft;
            var maxScroll = inner.scrollWidth - inner.clientWidth;
            // En baştaysa sol ok gizli
            if (scrollLeftVal <= 2) {
                leftBtn.style.visibility = 'hidden';
            } else {
                leftBtn.style.visibility = 'visible';
            }
            // En sondaysa sağ ok gizli
            if (scrollLeftVal >= maxScroll - 2) {
                rightBtn.style.visibility = 'hidden';
            } else {
                rightBtn.style.visibility = maxScroll > 0 ? 'visible' : 'hidden';
            }
        }
        leftBtn.addEventListener('click', function () {
            inner.scrollBy({ left: -(getItemWidth() + gap), behavior: 'smooth' });
            setTimeout(updateArrows, 300);
        });
        rightBtn.addEventListener('click', function () {
            inner.scrollBy({ left: getItemWidth() + gap, behavior: 'smooth' });
            setTimeout(updateArrows, 300);
        });
        inner.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        // Başlangıçta en başa kaydır ve okları güncelle
        inner.scrollLeft = 0;
        setTimeout(updateArrows, 100);

        // Mouse ile sürükleme (gelişmiş)
        // Sürükleme deneyimini iyileştir (daha akıcı ve takılmasız)
        let dragStarted = false;
        let lastX = 0;
        let velocity = 0;
        let animationFrame;
        function onMouseMove(e) {
            if (!isDown) return;
            e.preventDefault();
            dragStarted = true;
            const x = e.pageX;
            const walk = (x - startX);
            inner.scrollLeft = scrollLeft - walk;
            velocity = x - lastX;
            lastX = x;
        }
        function onMouseUp() {
            if (isDown) {
                isDown = false;
                inner.classList.remove('dragging');
                document.body.style.userSelect = '';
                // Kinetik kaydırma efekti (inertia)
                if (dragStarted && Math.abs(velocity) > 1) {
                    let inertia = velocity;
                    function inertiaScroll() {
                        if (Math.abs(inertia) > 0.5) {
                            inner.scrollLeft -= inertia;
                            inertia *= 0.92;
                            animationFrame = requestAnimationFrame(inertiaScroll);
                        } else {
                            cancelAnimationFrame(animationFrame);
                        }
                    }
                    inertiaScroll();
                }
                dragStarted = false;
                velocity = 0;
            }
        }
        inner.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            isDown = true;
            dragStarted = false;
            inner.classList.add('dragging');
            startX = e.pageX;
            lastX = e.pageX;
            scrollLeft = inner.scrollLeft;
            document.body.style.userSelect = 'none';
        });
        inner.addEventListener('mouseleave', onMouseUp);
        inner.addEventListener('mouseup', onMouseUp);
        inner.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, 500);
});